// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SimpleCardsGroup_wrapper__2Bvd5"};